import api from "./api";

export interface User {
  id: string;
  email: string;
  name: string | null;
  image: string | null;
  role: string;
}

export interface Session {
  user: User;
  session: {
    id: string;
    expiresAt: Date;
  };
}

export const authService = {
  /**
   * Initiate Google OAuth sign-in
   * BetterAuth uses POST /api/auth/sign-in/social with { provider: "google" }
   * Returns a redirect URL to Google's OAuth page
   */
  async signInWithGoogle(): Promise<void> {
    // callbackURL must be a full URL to the frontend, not just a path
    const callbackURL = `${window.location.origin}/dashboard`;
    const response = await api.post("/api/auth/sign-in/social", {
      provider: "google",
      callbackURL,
    });

    // BetterAuth returns a URL to redirect to Google OAuth
    if (response.data?.url) {
      window.location.href = response.data.url;
    }
  },

  /**
   * Get the current session
   * BetterAuth uses /api/auth/get-session
   */
  async getSession(): Promise<Session | null> {
    try {
      const response = await api.get("/api/auth/get-session");
      if (response.data?.session) {
        return {
          user: response.data.user,
          session: {
            id: response.data.session.id,
            expiresAt: new Date(response.data.session.expiresAt),
          },
        };
      }
      return null;
    } catch {
      return null;
    }
  },

  /**
   * Sign out the current user
   * BetterAuth uses POST /api/auth/sign-out
   */
  async signOut(): Promise<void> {
    await api.post("/api/auth/sign-out");
  },
};

export default authService;
